import React, { useState, useEffect } from "react";
import { Col, Card, CardBody, Form, Input } from "reactstrap";
import axios from "axios";
import { Link } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import PageSection from "../../../components/Loader/loader";

const SubscriptionsPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [noResultsFound, setNoResultsFound] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setloading] = useState(false);
  const [highlightedRow, setHighlightedRow] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);

  const getSubscriptions = async () => {
    try {
      setloading(true);
      const response = await axios.get(
        "https://substest.minimis.cloud/customers"
      );
      setSubscriptions(response.data.data || []);
      setloading(false);
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
    }
  };
  useEffect(() => {
    getSubscriptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (searchTerm) {
      const filtered = subscriptions.filter((sub) =>
        sub.email.toLowerCase().includes(searchTerm.toLowerCase())
      );
      if (filtered.length === 0) {
        setNoResultsFound(true);
      } else {
        setNoResultsFound(false);
      }
      setSubscriptions(filtered);
    }
    if (searchTerm === "") {
      getSubscriptions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  const totalPages = Math.ceil(subscriptions.length / itemsPerPage);
  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const displayedPaginationItems = subscriptions.slice(
    indexOfFirstItem,
    indexOfFirstItem + itemsPerPage
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const renderPageNumbers = () => {
    const pageNumbers = [];
    let startPage, endPage;

    if (totalPages <= 3) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 2) {
        startPage = 1;
        endPage = 3;
      } else if (currentPage + 1 >= totalPages) {
        startPage = totalPages - 2;
        endPage = totalPages;
      } else {
        startPage = currentPage - 1;
        endPage = currentPage + 1;
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={`page-item ${i === currentPage ? "active" : ""}`}
        >
          <Link to="#" className="page-link" onClick={() => paginate(i)}>
            {i}
          </Link>
        </li>
      );
    }

    return pageNumbers;
  };
  const capitalizeFirst = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  return (
    <React.Fragment>
      <Toaster />
      <Col lg={12}>
        <Card style={{ paddingBottom: "55px" }}>
          <CardBody>
            <div className="d-flex justify-content-between align-items-center ">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="card-title mt-1">Subscriptions</h4>
              </div>
              <div className="d-flex align-items-center ">
                <Form
                  className="app-search d-none d-lg-block pt-2 mt-2"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <Input
                      type="text"
                      className="form-control"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      placeholder="Search by email"
                    />
                    <span className="ri-search-line"></span>
                  </div>
                </Form>
              </div>
            </div>

            {loading || loading ? (
              <div
                className="table-responsive p-2"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "50%",
                }}
              >
                <PageSection />
              </div>
            ) : (
              <div className="table-responsive">
                <table
                  className="table table-bordered"
                  style={{ minWidth: "max-content" }}
                >
                  <thead>
                    <tr>
                      <th className="p-3">Id.</th>
                      <th className="p-3">Name</th>
                      <th className="p-3">Email</th>
                      <th className="p-3">Phone</th>
                      <th className="p-3">Referral Link</th>
                      <th className="p-3">Subscriptions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayedPaginationItems.length === 0 ? (
                      <tr>
                        <td colSpan="12" className="text-center p-5">
                          {noResultsFound ? (
                            <div>No data found</div>
                          ) : (
                            <PageSection />
                          )}
                        </td>
                      </tr>
                    ) : (
                      displayedPaginationItems.map((row, index) => (
                        <tr
                          onMouseEnter={() => setHighlightedRow(row.id)}
                          onMouseLeave={() => setHighlightedRow(null)}
                          key={row.id}
                          style={{
                            cursor: "pointer",
                            backgroundColor:
                              row.id === highlightedRow ? "#e5f2ff" : "white",
                          }}
                        >
                          <td>{indexOfFirstItem + index + 1}</td>
                          <td className="p-3">{row.name}</td>
                          <td className="p-3">{row.email}</td>
                          <td className="p-3">{row.phone}</td>
                          <td className="p-3">
                            <a
                              href={row.referralLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open link
                            </a>
                          </td>

                          <td className="p-3">
                            {row.subscriptions.length
                              ? row.subscriptions
                                  .map((sub) =>
                                    sub.status === "trialing"
                                      ? "Trial"
                                      : capitalizeFirst(sub.status.toString())
                                  )
                                  .join(" | ")
                              : "N/A"}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <nav>
                  <ul
                    className="pagination justify-content-end"
                    style={{
                      position: "absolute",
                      marginTop: "15px",
                      right: "20px",
                    }}
                  >
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <Link
                        to="#"
                        className="page-link"
                        onClick={() => paginate(currentPage - 1)}
                      >
                        &laquo;
                      </Link>
                    </li>
                    {renderPageNumbers()}
                    <li
                      className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                    >
                      <Link
                        to="#"
                        className="page-link"
                        onClick={() => paginate(currentPage + 1)}
                      >
                        &raquo;
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default SubscriptionsPage;
